<template>
  <div>
    <div>
      <div v-if="loaded && companyDestinations.length === 0">
        <div class="alert alert-primary" role="alert">مقصدی یافت نشد.</div>
      </div>
    </div>
    <div>
      <b-row align-v="center" align-h="between">
        <b-col align-self="center" sm="12" lg="4"
          ><b-form-input
            v-model="searchDestination"
            placeholder="جستجو مقصد بر اساس نام "
            class="mb-3"
            @keypress="notSpace($event)"
            @keydown.enter="updateDestinations"
          ></b-form-input
        ></b-col>
        <b-col align-v="center" sm="8" lg="4" align-h="between">
          <button
            type="button"
            class="btn btn-primary mb-3"
            title="جستجو"
            @click="updateDestinations"
            :disabled="!searchDestination"
          >
            <i class="fal fa-search pt-1" />
            جستجو
          </button></b-col
        >
        <b-col></b-col>
      </b-row>
    </div>
    <div
      v-if="loaded && companyDestinations.length"
      class="card card-custom gutter-b"
    >
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>نام</th>
                <th>کاربر</th>
                <th>تاریخ</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="destination in companyDestinations"
                :key="destination.id"
              >
                <td class="text-nowrap">
                  <div class="w-auto btn-clean d-flex px-2">
                    <span class="symbol symbol-25 symbol-light-success">
                      <img
                        :alt="destination.name"
                        :src="
                          `/media/destinations/${
                            destinationTypes[destination.type]
                          }.png`
                        "
                      />
                    </span>
                    <span class="ml-3 font-size-lg pt-1">
                      {{ destination.name }}
                    </span>
                  </div>
                </td>
                <td class="text-nowrap ">
                  <router-link
                    :to="{
                      name: 'company-users-show',
                      params: { id: destination.user_id }
                    }"
                  >
                    {{ gFullName(destination.user) }}
                  </router-link>
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(destination.created_at) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'company-destinations-show',
                      params: { id: destination.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>

                  <button
                    class="btn btn-xs btn-outline-danger mr-1"
                    @click="destroy(destination.id)"
                  >
                    <i class="flaticon2-trash"></i>
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="overflow-auto mt-5"
      v-if="companyDestinationsPagination.lastPage > 1"
    >
      <b-pagination
        v-model="companyDestinationsPagination.currentPage"
        :total-rows="companyDestinationsPagination.total"
        :per-page="companyDestinationsPagination.perPage"
        aria-controls="my-table"
        @input="updateDestinations()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_COMPANY_DESTINATIONS } from "@/core/services/store/company/destinations.module";
import { DESTROY_DESTINATION } from "@/core/services/store/destinations.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "companyDestinations",
  data() {
    return {
      loaded: false,
      searchDestination: ""
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.currentUserProperty.title ?? "شرکت",
        route: { name: "company-dashboard" }
      },
      { title: "مقصد‌ها" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});

    this.updateDestinations();
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "companyDestinations",
      "companyDestinationsPagination",
      "destinationTypes"
    ])
  },
  methods: {
    updateDestinations() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_COMPANY_DESTINATIONS, this.searchDestination)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف مقصد اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#1e1f22",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_DESTINATION, id).then(() => {
            this.updateDestinations();
            Swal.fire({
              position: "center",
              icon: "success",
              title: "حذف با موفقیت انجام شد.",
              showConfirmButton: false,
              timer: 1500
            });
          });
        }
      });
    }
  }
};
</script>
